import { getQuery } from 'sutils';

/**
 * 当前处于相似度检测的环境
 * 跑版项目运行tdoc e2e时会在链接加上isSimilarityEnv标识环境
 */
export function isSimilarityEnv() {
    return getQuery('isSimilarityEnv') === '1';
}

/**
 * 当前处于性能自动化测试的环境
 * 性能自动化的蓝盾流水线运行 e2e时会在链接加上Mode标识环境
 */
export function isDsiReportEnv() {
    return getQuery('mode') === 'test';
}
